import {
    isDiningEntity,
    isEventEntity,
    isInvoiceEntity,
    isPackageEntity,
    isTravelEntity,
} from './entityCheckHelpers';
import * as txpConstants from '../../helpers/TxpConstants';

export default function selectLoadingImage(isLoading: boolean, entityNamesMap: number): string {
    if (isTravelEntity(entityNamesMap)) {
        return isLoading
            ? txpConstants.TRAVEL_LOADING_VIEW
            : txpConstants.TRAVEL_LOADING_STATIC_VIEW;
    } else if (isPackageEntity(entityNamesMap)) {
        return isLoading
            ? txpConstants.PACKAGE_LOADING_VIEW
            : txpConstants.PACKAGE_LOADING_STATIC_VIEW;
    } else if (isDiningEntity(entityNamesMap)) {
        return isLoading
            ? txpConstants.DINING_LOADING_VIEW
            : txpConstants.DINING_LOADING_STATIC_VIEW;
    } else if (isEventEntity(entityNamesMap)) {
        return isLoading ? txpConstants.EVENT_LOADING_VIEW : txpConstants.EVENT_LOADING_STATIC_VIEW;
    } else if (isInvoiceEntity(entityNamesMap)) {
        return isLoading
            ? txpConstants.INVOICE_LOADING_VIEW
            : txpConstants.INVOICE_LOADING_STATIC_VIEW;
    } else {
        return isLoading
            ? txpConstants.DEFAULT_LOADING_VIEW
            : txpConstants.DEFAULT_LOADING_STATIC_VIEW;
    }
}
